export const mallInfoColumns = [
  {
    title: "店铺名称",
    dataIndex: "mallName",
  },
  {
    title: "店铺 ID",
    dataIndex: "mallId",
  },
];

export enum DrawerEnums {
  /** 管理店铺的Drawer */
  MANAGE,
  /** 添加店铺的Drawer */
  ADD,
}

export const BRAND_INFO_COLUMNS = [
  {
    title: "品牌名称",
    dataIndex: "brandName",
  },
];
